import { instance } from "api/apiBase";

/**
 * One saved filter selection per user per screen.
 *
 * Reads come down on the auth payload (`Authed.filter_preferences`), so there
 * is no GET here — only the writes. The row is unique on (user, context), so
 * the first save creates and every later one patches the id that came back.
 */
type UserFilterPreference = {
  id: number;
  context: string;
  filters: Record<string, unknown>;
};

export const createFilterPreference = async (
  context: string,
  filters: Record<string, unknown>
): Promise<UserFilterPreference> =>
  (
    await instance.post(`portal/v1/user_filter_preferences`, {
      context,
      filters
    })
  ).data;

export const updateFilterPreference = async (
  id: number,
  filters: Record<string, unknown>
): Promise<UserFilterPreference> =>
  (await instance.patch(`portal/v1/user_filter_preferences/${id}`, { filters }))
    .data;
